/**
 * Like button component. Send ajax and count likes for different collections
 */
;
(function () {

    const $like = $('.js-c-like');
    if (!$like.length) return false;

    $like.on('click', function (e) {
        e.stopPropagation();

        const entityId = $(this).data('entityId');
        const colorDefault = $(this).data('colorDefault') || 'u-db';
        const colorActive = $(this).data('colorActive') || 'u-base';
        const checkedClass = 'is-checked ' + colorActive;
        const unCheckedClass = colorDefault + ' hover:' + colorActive;
        let isChecked = $(this).hasClass(checkedClass);
        const $likeSame = $like.filter('*[data-entity-id="' + entityId +'"]');
        const $counter = $('.js-c-like-counter[data-entity-id="' + entityId +'"]');
        let data = {};
        let url = `/ajax/favorite/scene_id/${entityId}`;

        // send request
        $.ajax({
            method: 'GET',
            url: url,
            success: function (response) {
                // console.log(response);
            }
        });

        if (isChecked) {
            $likeSame.removeClass(checkedClass);
            $likeSame.addClass(unCheckedClass);
            $counter.each(function () {
                let $currentLikes = parseInt($(this).text(), 10) || 0;
                if ($currentLikes > 0) {
                    $(this).text(parseInt($currentLikes, 10) - 1);
                }
            });
            $.snackbar($(this).data('messageRemoved'));
        } else {
            $likeSame.removeClass(unCheckedClass);
            $likeSame.addClass(checkedClass);
            $counter.each(function () {
                let $currentLikes = parseInt($(this).text(), 10) || 0;
                $(this).text(parseInt($currentLikes, 10) + 1);
            });
            $.snackbar($(this).data('messageAdded'));
        }
    });

})();